(function () {
	'use strict';
	angular.module('app.core')
		.service('filterDefinitionsService', filterDefinitionsService);

	filterDefinitionsService.$inject = ['$translate', 'URLS', '$experiments', 'flexFilters', 'siteService', 'customFieldsFilters', '$filter'];

	function filterDefinitionsService($translate, URLS, $experiments, flexFilters, siteService, customFieldsFilters, $filter) {
		var userAdminSites = siteService.getAdminSitesByCustomer(globalConfig.customer.id).map(function(f) { return f.id;});
		return {
			getFilterDefinitions: getFilterDefinitions,
			clearSelectedAndUnselected: clearSelectedAndUnselected
		};

		function getFilterDefinitions() {
			var filters = {
				// multiselect filters. multiselect is the default type
				// defaults are applied as needed at the end of this function
				'AbcClass': {
					id: 'abcClass',
					displayName: 'ABC Rank',
					comparisonKey: 'abcClass',
					label: 'abcClass',
					url: String.format(URLS.abcClasses, globalConfig.factory.id),
					unformattedUrl: URLS.abcClasses,
					updateOnFactory: true
				},
				'Activated': {
					id: 'activated',
					displayName: 'Active',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'Yes',
						'value': 'active'
					}, {
						'label': 'No',
						'value': 'inactive'
					}]
				},
				'AllMetricCategories': {
					id: 'category',
					displayName: 'Category',
					label: 'categoryName',
					comparisonKey: 'categoryName',
					url: String.format(URLS.allMetricCategories, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.allMetricCategories,
					authz: ['filters', 'category']
				},
				'AllFactories': {
					id: 'allFactory',
					displayName: 'Site',
					label: 'name',
					comparisonKey: 'id',
					url: URLS.allFactories
				},
				'AllCustomerFactories': {
					id: 'allCustomerFactory',
					displayName: 'Site',
					label: 'factoryAlias',
					comparisonKey: 'id',
					url: URLS.allCustomerFactories
				},
				'AllFactoryTypes': {
					id: 'factoryType',
					displayName: 'Site Type',
					label: 'factoryType',
					comparisonKey: 'factoryType',
					url: URLS.allFactoryTypes
				},
				'AssignToPlanner': {
					id: 'isReassign',
					displayName: 'Reassign',
					label: 'display',
					comparisonKey: 'value',
					objectList: [{
						value: 1,
						display: 'Yes'
					}, {
						value: 0,
						display: 'No'
					}]
				},
				'Buyer': {
					id: 'buyerCode',
					displayName: 'Buyer',
					label: 'buyerCode',
					comparisonKey: 'buyerCode',
					url: String.format(URLS.buyers, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.buyers,
					disabled: false,
					undefinedMap: JSON.stringify({ 'UndefinedBuyer': 'Buyer Not Defined', 'UnassignedBuyer': 'No Assigned Buyer' }),
					authz: ['filters', 'buyer'],
					dashboardEventName: 'adfBuyerChanged',
					isCaseSensitive: false,
					checkMyItems: true
				},
				'BusinessUnit': {
					id: 'businessunit',
					displayName: 'Business Unit',
					label: 'businessunit',
					comparisonKey: 'businessunit',
					sendAllValues: true,
					dashboardEventName: 'adfBusinessUnitChanged',
					authz: ['filters', 'factoryHierarchy']
				},
				'CommitDateStatus': {
					id: 'commitDateStatus',
					displayName: 'Commit Date Status',
					label: 'commitDateStatus',
					comparisonKey: 'commitDateStatus',
					objectList: [
						{ commitDateStatus: 'Late' },
						{ commitDateStatus: 'None'},
						{ commitDateStatus: 'OK' }
					]
				},
				'CreatedBy': {
					id: 'creatorNdx',
					displayName: 'Created By',
					label: 'responsibleName',
					comparisonKey: 'userNdx',
					url: String.format(URLS.responsibleUsers, globalConfig.factory.id),
					unformattedUrl: URLS.responsibleUsers,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'createdBy']
				},
				'CriticalIndicator': {
					id: 'criticalIndicator',
					displayName: 'Critical Indicator',
					label: 'criticalIndicator',
					comparisonKey: 'criticalIndicator',
					url: String.format(URLS.criticalIndicators, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.criticalIndicators,
					authz: ['filters', 'criticalIndicator']
				},
				'CriticalIndicatorNew': {
					id: 'criticalIndicator',
					displayName: 'Critical Indicator',
					label: 'criticalIndicator',
					comparisonKey: 'criticalIndicator',
					url: String.format(URLS.criticalIndicators, globalConfig.factory.id) + '?useNewReport=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.criticalIndicators + '?useNewReport=true',
					authz: ['filters', 'criticalIndicator']
				},
				'DeliveryStatusName': {
					id: 'deliveryStatus',
					displayName: 'Delivery Status',
					label: 'deliveryStatus',
					comparisonKey: 'deliveryStatus',
					objectList: [{
						deliveryStatus: 'Delivered - Early'
					}, {
						deliveryStatus: 'Delivered - Late'
					}, {
						deliveryStatus: 'Delivered - On-time'
					}, {
						deliveryStatus: 'Open - Behind Schedule'
					}, {
						deliveryStatus: 'Open'
					}]
				},
				'ConfirmationStatusUsed': {
					id: 'confirmationStatusUsed',
					displayName: 'Expected Delivery Date Status',
					label: 'displayName',
					comparisonKey: 'displayName',
					authz: ['filters', 'confirmationStatuses']
				},
				'FirstPoConfirmationStatus': {
					id: 'firstPurchaseOrderDateStatus',
					displayName: 'Supply Order Expected Delivery Date Status',
					label: 'displayName',
					comparisonKey: 'displayName',
					authz: ['filters', 'confirmationStatuses']
				},
				'Division': {
					id: 'division',
					displayName: 'Division',
					label: 'division',
					comparisonKey: 'division',
					sendAllValues: true,
					authz: ['filters', 'factoryHierarchy']
				},
				'EndItem': {
					id: 'endItem',
					displayName: 'End Item',
					label: 'endItemCode',
					comparisonKey: 'endItemNdx',
					useNotSelected: true,
					updateOnFactory: true,
					url: String.format(URLS.endItems, globalConfig.factory.id),
					disabled: false,
					undefinedMap: JSON.stringify({ 'UndefinedItem': 'No End Item' }),
					unformattedUrl: URLS.endItems,
					noEscapeComma: true,
					staticOption: [{
						'endItemCode': 'None',
						'endItemNdx': 'None',
						'selectedByDefault': false
					}],
					authz: ['filters', 'endItemCode']
				},
				'Entity': {
					id: 'entity',
					displayName: 'Entity',
					label: 'entity',
					comparisonKey: 'entity',
					sendAllValues: true,
					authz: ['filters', 'factoryHierarchy']
				},
				'EntryType': {
					id: 'entryType',
					displayName: 'Entry Type',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Automatic',
						'value': 'Automatic'
					}, {
						'name': 'Manual',
						'value': 'Manual'
					}, {
						'name': 'System',
						'value': 'ProcurementLog'
					}]
				},
				'ERP Order Policy': {
					id: 'erpOrderPolicy',
					displayName: 'ERP Order Policy',
					label: 'erpOrderPolicy',
					comparisonKey: 'erpOrderPolicy',
					url: String.format(URLS.erpOrderPolicies, globalConfig.factory.id),
					unformattedUrl: URLS.erpOrderPolicies,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					disabled: true,
					authz: ['filters', 'erpOrderPolicy'],
					dashboardEventName: 'adfErpOrderPolicyChanged'
				},
				'ERP Status': {
					id: 'erpStatus',
					displayName: 'ERP Status',
					label: 'erpStatus',
					comparisonKey: 'erpStatus',
					url: String.format(URLS.erpStatuses, globalConfig.factory.id),
					unformattedUrl: URLS.erpStatuses,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'erpStatus']
				},
				'ERP Document Type': {
					id: 'erpDocumentType',
					displayName: 'ERP Document Type',
					label: 'erpDocumentType',
					comparisonKey: 'erpDocumentType',
					url: String.format(URLS.erpDocumentTypes, globalConfig.factory.id),
					unformattedUrl: URLS.erpDocumentTypes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'erpDocumentType']
				},
				'ExceptionMessage': {
					id: 'exceptionMessage',
					displayName: 'ERP exception message',
					label: 'exceptionMsg',
					comparisonKey: 'exceptionMsg',
					url: String.format(URLS.exceptionMessages, globalConfig.factory.id),
					unformattedUrl: URLS.exceptionMessages,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'exceptionMsg']
				},
				'First PO ERP Status': {
					id: 'firstPurchaseOrderErpStatus',
					displayName: 'Supply Order ERP Status',
					label: 'erpStatus',
					comparisonKey: 'erpStatus',
					url: String.format(URLS.erpStatuses, globalConfig.factory.id),
					unformattedUrl: URLS.erpStatuses,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'erpStatus'],
					staticOption: [{
						'erpStatus': 'No PO for shortage',
						'class': 'staticOption'
					}]
				},
				'Factory': {
					id: 'factory',
					displayName: 'Site',
					label: 'alias',
					comparisonKey: 'id',
					url: URLS.factories + '?opsFactNdx=' + globalConfig.factory.id,
					disabled: false,
					authz: ['filters', 'factoryHierarchy'],
					dashboardEventName: 'adfFactoryChanged'
				},
				'FinishedGoodsFlag': {
					id: 'finishedGoodFlag',
					displayName: 'Type',
					label: 'deliveryStatus',
					comparisonKey: 'finishedGoodFlag',
					objectList: [{
						finishedGoodFlag: '1',
						deliveryStatus: 'Finished Goods'
					}, {
						finishedGoodFlag: '0',
						deliveryStatus: 'Semi-Finished'
					}]
				},
				'Global Supplier': {
					id: 'globalSupplierName',
					displayName: 'Global Supplier',
					label: 'globalSupplierName',
					comparisonKey: 'globalSupplierName',
					url: String.format(URLS.globalSuppliers, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.globalSuppliers,
					disabled: false,
					undefinedMap: JSON.stringify({ 'UndefinedSupplier': 'Global Supplier Not Defined', 'UnassignedGlobalSupplier': 'No Assigned Global Supplier' }),
					authz: ['filters', 'globalSuppliers'],
					dashboardEventName: 'adfGlobalSupplierChanged',
					isCaseSensitive: false
				},
				'IndirectSpendCategory': {
					id: 'indirectSpendCategory',
					displayName: 'Indirect Spend Category',
					label: 'indirectSpendCategory',
					comparisonKey: 'indirectSpendCategory',
					url: String.format(URLS.indirectSpendCategories, globalConfig.factory.id),
					unformattedUrl: URLS.indirectSpendCategories,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					disabled: true,
					authz: ['filters', 'indirectSpendCategory']
				},
				'AssociatedSpendItemCode': {
					id: 'associatedSpendItemCode',
					displayName: 'Associated Item Code',
					label: 'associatedSpendItemCode',
					comparisonKey: 'associatedSpendItemCode',
					url: String.format(URLS.associatedSpendItemCodes, globalConfig.factory.id),
					unformattedUrl: URLS.associatedSpendItemCodes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					disabled: true,
					authz: ['filters', 'indirectSpendCategory']
				},
				'InventoryActionStatus': {
					id: 'inventoryActionStatus',
					displayName: 'Status',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Open',
						'value': 'open'
					}, {
						'name': 'Fixed',
						'value': 'fixed'
					}, {
						'name': 'Unable to Fix',
						'value': 'wontFix'
					}, {
						'name': 'Invalid',
						'value': 'invalid'
					}]
				},
				'PoAction': {
					id: 'poAction',
					displayName: 'PO Action',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Move In',
						'value': 'Move In'
					}, {
						'name': 'Move In and Reduce',
						'value': 'Move In and Reduce'
					}, {
						'name': 'Move Out',
						'value': 'Move Out'
					}, {
						'name': 'Move Out and Reduce',
						'value': 'Move Out and Reduce'
					}, {
						'name': 'Cancel',
						'value': 'Cancel'
					}, {
						'name': 'Split',
						'value': 'Split'
					}, {
						'name': 'Split and Reduce',
						'value': 'Split and Reduce'
					}, {
						'name': 'None',
						'value': ''
					}]
				},
				'InventoryActionStatusOpenFixedWontExpired': {
					id: 'inventoryActionStatus',
					displayName: 'Status',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Open',
						'value': 'isOpen'
					}, {
						'name': 'Fixed',
						'value': 'isFixed'
					}, {
						'name': 'In Progress',
						'value': 'isSnoozed'
					}, {
						'name': 'Unable to Fix',
						'value': 'isUnableToFix'
					}, {
						'name': 'Expired',
						'value': 'isExpired'
					}]
				},
				'InventoryActionStatusIncludeHidden': {
					id: 'inventoryActionStatus',
					displayName: 'Status',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Open',
						'value': 'isOpen'
					}, {
						'name': 'Fixed',
						'value': 'isFixed'
					}, {
						'name': 'In Progress',
						'value': 'isSnoozed'
					}, {
						'name': 'Unable to Fix',
						'value': 'isUnableToFix'
					}, {
						'name': 'Expired',
						'value': 'isExpired'
					}, {
						'name': 'Potential',
						'value': 'isPotential'
					}, {
						'name': 'Excluded',
						'value': 'isBlacklisted'
					}, {
						'name': 'Near Shortage',
						'value': 'hasNearTermShortage'
					}, {
						'name': 'Less Than MOQ',
						'value': 'isLessThanMOQ'
					}, {
						'name': 'Below Min',
						'value': 'isBelowMin'
					}, {
						'name': 'Volatile Demand',
						'value': 'isVolatile'
					}, {
						'name': 'Volatile Demand (new)',
						'value': 'isVolatileNew'
					}, {
						'name': 'Has Extra Requirements',
						'value': 'hasExtraRequirements'
					}, {
						'name': 'Has Consignment Stock',
						'value': 'hasConsignmentStock'
					}, {
						'name': 'Has Work Transfer',
						'value': 'hasWorkTransfer'
					}]
				},
				'Item Group': {
					id: 'itemGroupNdx',
					displayName: 'Item Group',
					label: 'itemGroupName',
					comparisonKey: 'itemGroupNdx',
					url: String.format(URLS.itemGroups, globalConfig.factory.id),
					unformattedUrl: URLS.itemGroups + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					noEscapeComma: true,
					alternateKey: 'itemGroupName',
					authz: ['filters', 'itemGroup'],
					dashboardEventName: 'adfItemGroupChanged'
				},
				'ItemType': {
					id: 'itemType',
					displayName: 'Item Type',
					label: 'itemType',
					comparisonKey: 'itemType',
					objectList: [{
						'itemType': 'Manufactured'
					}, {
						'itemType': 'Purchased'
					}],
					authz: ['filters', 'itemType']
				},
				'ShortageTypeLOB': {
					id: 'shortageType',
					displayName: 'Shortage Type',
					label: 'display',
					comparisonKey: 'value',
					objectList: [{
						'display': 'Current',
						'value': 'current'
					}, {
						'display': 'Future',
						'value': 'future'
					}, {
						'display': 'None',
						'value': 'none'
					}],
					authz: ['filters', 'shortageType']
				},
				'ShortageTypeSBI': {
					id: 'shortageType',
					displayName: 'Shortage Type',
					label: 'display',
					comparisonKey: 'value',
					objectList: [{
						'display': 'Current',
						'value': 'current'
					}, {
						'display': 'Future',
						'value': 'future'
					}],
					authz: ['filters', 'shortageType']
				},
				'Order Numbers With Shortage': {
					id: 'orderNumberWithShortage',
					displayName: 'Order Number',
					label: 'orderNumber',
					comparisonKey: 'orderNumber',
					url: String.format(URLS.orderNumbersWithShortage, globalConfig.factory.id),
					unformattedUrl: URLS.orderNumbersWithShortage,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					authz: ['filters', 'orderNumbersWithShortage'],
					dynamicWidth: true
				},
				'Locations With Shortage': {
					id: 'locationWithShortage',
					displayName: 'Location',
					label: 'location',
					comparisonKey: 'location',
					url: String.format(URLS.locationsWithShortage, globalConfig.factory.id),
					unformattedUrl: URLS.locationsWithShortage,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					authz: ['filters', 'locationsWithShortage']
				},
				'Location': {
					id: 'location',
					displayName: 'Location',
					label: 'location',
					comparisonKey: 'location',
					url: String.format(URLS.familyGroups, globalConfig.factory.id),
					unformattedUrl: URLS.familyGroups,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					authz: ['filters', 'location']
				},
				'LocationNew': {
					id: 'location',
					displayName: 'Location',
					label: 'location',
					comparisonKey: 'location',
					url: String.format(URLS.familyGroups, globalConfig.factory.id) + '?useNewReport=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.familyGroups + '?useNewReport=true',
					useNotSelected: true,
					authz: ['filters', 'location']
				},
				'LateDeliveryCategoryDescription': {
					id: 'lateDeliveryDescription',
					displayName: 'Late/Early Delivery Cause',
					label: 'display',
					comparisonKey: 'id',
					url: String.format(URLS.supplierLateDelivery, globalConfig.factory.id) + '/Description',
					unformattedUrl: URLS.supplierLateDelivery + '/Description',
					useNotSelected: true,
					sendAllValues: true,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					staticOption: [{
						'display': 'None',
						'id': 'LEANDNA_NONE'
					}],
					groupKey: 'deliveryStatus',
					groupLabels: {
						Late: $translate.instant('Late'),
						Early: $translate.instant('Early')
					},
					authz: ['filters', 'lateDeliveryDescription']
				},
				'LateDeliveryCategoryLiability': {
					id: 'lateDeliveryLiability',
					displayName: 'Late/Early Delivery Liability',
					label: 'display',
					comparisonKey: 'value',
					sendAllValues: true,
					objectList: [{
						'display': globalConfig.customer.name,
						'value': 'Customer'
					}, {
						'display': 'Vendor',
						'value': 'Vendor'
					}],
					useNotSelected: true,
					authz: []
				},
				'POStatusCategory': {
					id: 'poStatusCategoryNdx',
					displayName: 'Supply Order Status Category',
					label: 'description',
					comparisonKey: 'ndx',
					url: String.format(URLS.poStatusCategoriesDimension, globalConfig.customer.id),
					staticOption: [{
						'description': 'None',
						'ndx': 'LEANDNA_NONE'
					}],
					optionMap: function (item) {
						if (item.stateType === 'Archived') {
							item.description += ' (' + $translate.instant('Archived') + ')';
						}
						return item;
					},
					useNotSelected: true,
					authz: ['filters', 'poStatusCategories']
				},
				'MaterialGroup': {
					id: 'materialGroup',
					displayName: 'Material Group',
					label: 'materialGroup',
					comparisonKey: 'materialGroup',
					url: String.format(URLS.materialGroups, globalConfig.factory.id),
					unformattedUrl: URLS.materialGroups,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					undefinedMap: JSON.stringify({'UndefinedMaterialGroup' : 'Material Group Not Defined'}),
					authz: ['filters', 'materialGroup']
				},
				'MaterialType': {
					id: 'materialType',
					displayName: 'Material Type',
					label: 'materialType',
					comparisonKey: 'materialType',
					url: String.format(URLS.materialTypes, globalConfig.factory.id),
					unformattedUrl: URLS.materialTypes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'materialType']
				},
				'Metric': {
					id: 'metric',
					displayName: 'Metric',
					label: 'metricName',
					comparisonKey: 'metricNdx',
					url: String.format(URLS.allMetrics, globalConfig.factory.id),
					unformattedUrl: URLS.allMetrics + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					strip: true,
					authz: ['filters', 'user'],
					dashboardEventName: 'adfMetricChanged',
					alternateComparisonKey: ['metricName', 'crossSiteName'],
					extraParams: {
						manualOnly: true
					},
					extraParamReportNames: ['EnterMetricData']

				},
				'WeeklyTargetMetric': {
					id: 'metric',
					displayName: 'Metric',
					label: 'metricName',
					comparisonKey: 'metricNdx',
					url: String.format(URLS.allMetrics, globalConfig.factory.id),
					unformattedUrl: URLS.allMetrics + '?targetPeriodType=Weekly&grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					strip: true,
					authz: ['filters', 'user'],
					dashboardEventName: 'adfMetricChanged',
					alternateComparisonKey: ['metricName', 'crossSiteName']
				},
				'MonthlyTargetMetric': {
					id: 'metric',
					displayName: 'Metric',
					label: 'metricName',
					comparisonKey: 'metricNdx',
					url: String.format(URLS.allMetrics, globalConfig.factory.id),
					unformattedUrl: URLS.allMetrics + '?targetPeriodType=Monthly&grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					strip: true,
					authz: ['filters', 'user'],
					dashboardEventName: 'adfMetricChanged',
					alternateComparisonKey: ['metricName', 'crossSiteName']
				},
				'MetricCategories': {
					id: 'categoryName',
					displayName: 'Category',
					label: 'categoryName',
					comparisonKey: 'categoryName',
					url: String.format(URLS.metricCategories, globalConfig.factory.id),
					unformattedUrl: URLS.metricCategories,
					storeFactoryNdxs: true,
					updateOnFactory: true,
					authz: ['filters', 'category'],
					dashboardEventName: 'adfCategoryChanged'
				},
				'MetricFrequency': {
					id: 'metricFrequency',
					displayName: 'Metric Frequency',
					label: 'display',
					comparisonKey: 'frequency',
					disabled: false,
					objectList: [{
						'frequency': 'Daily',
						'display': 'Daily'
					}, {
						'frequency': 'Weekly',
						'display': 'Weekly'
					}, {
						'frequency': 'Monthly',
						'display': 'Monthly'
					}],
					dashboardEventName: 'adfFrequencyChanged'
				},
				'MetricOwner': {
					id: 'metricOwner',
					displayName: 'Metric Owner',
					label: 'name',
					comparisonKey: 'userNdx',
					url: String.format(URLS.metricOwners, globalConfig.factory.id),
					unformattedUrl: URLS.metricOwners,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					staticOption: [{
						'name': 'My Metrics (' + globalConfig.user.firstName + ' ' + globalConfig.user.lastName + ')',
						'userNdx': globalConfig.user.id,
						'class': 'staticOption',
						'excludeMatchingOption': true
					}],
					authz: ['filters', 'user']
				},
				'MetricTypes': {
					id: 'typeName',
					displayName: 'Type',
					label: 'typeName',
					comparisonKey: 'typeName',
					url: String.format(URLS.metricTypes, globalConfig.factory.id),
					unformattedUrl: URLS.metricTypes,
					authz: ['filters', 'types'],
					dashboardEventName: 'adfTypeChanged',
					updateOnFactory: true,
					storeFactoryNdxs: true
				},
				'MrpElement': {
					id: 'mrpElement',
					displayName: 'MRP Element',
					label: 'mrpElement',
					comparisonKey: 'mrpElement',
					url: String.format(URLS.mrpElements, globalConfig.factory.id),
					unformattedUrl: URLS.mrpElements,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					undefinedMap: JSON.stringify({ 'UndefinedMrpElement': 'MRP Element Not Defined' }),
					authz: ['filters', 'mrpElement']
				},
				'ErpType': {
					id: 'erpType',
					displayName: 'ERP Type',
					label: 'erpType',
					comparisonKey: 'erpType',
					url: String.format(URLS.mrpElements, globalConfig.factory.id) + '?useNewReport=true',
					unformattedUrl: URLS.mrpElements + '?useNewReport=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					undefinedMap: JSON.stringify({ 'UndefinedMrpElement': 'ERP Type Not Defined' }),
					authz: ['filters', 'mrpElement']
				},
				'Order': {
					id: 'order',
					displayName: 'Order',
					label: 'order',
					comparisonKey: 'order',
					url: String.format(URLS.shipsets, globalConfig.factory.id),
					unformattedUrl: URLS.shipsets,
					updateOnFactory: true,
					authz: ['filters', 'order']
				},
				'OrderNumber': {
					id: 'orderNumber',
					displayName: 'Customer Order',
					label: 'orderNumber',
					comparisonKey: 'orderNumber',
					url: String.format(URLS.shipsets, globalConfig.factory.id) + '?useNewReport=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.shipsets + '?useNewReport=true',
					authz: ['filters', 'order']
				},
				'Order Policy': {
					id: 'orderPolicy',
					displayName: 'Order Policy',
					label: 'orderPolicy',
					comparisonKey: 'orderPolicy',
					url: String.format(URLS.orderPolicies, globalConfig.factory.id),
					unformattedUrl: URLS.orderPolicies,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					disabled: true,
					authz: ['filters', 'orderPolicy'],
					dashboardEventName: 'adfOrderPolicyChanged'
				},
				'Planner': {
					id: 'planners',
					displayName: 'Planner',
					label: 'planner',
					comparisonKey: 'planner',
					url: String.format(URLS.planners, globalConfig.factory.id),
					unformattedUrl: URLS.planners,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					undefinedMap: JSON.stringify({ 'UndefinedPlanner': 'Planner Not Defined' }),
					authz: ['filters', 'planner'],
					dashboardEventName: 'adfPlannerChanged'
				},
				'Planner2': {
					id: 'planner',
					displayName: 'Planner',
					label: 'planner',
					comparisonKey: 'planner',
					url: String.format(URLS.planners, globalConfig.factory.id),
					unformattedUrl: URLS.planners,
					useNotSelected: true,
					updateOnFactory: true,
					undefinedMap: JSON.stringify({ 'UndefinedPlanner': 'Planner Not Defined' }),
					authz: ['filters', 'planner']
				},
				'SupplyOrderImpactingShortage': {
					id: 'supplyOrderImpactingShortage',
					displayName: 'Supply Order Impacting Shortage',
					noEscapeComma: true,
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						name: 'Yes',
						value: 'Yes'
					}, {
						name: 'No',
						value: 'No,noValue'
					}]
				},
				'PoPrice': {
					id: 'poPrice',
					displayName: 'Price',
					label: 'poPrice',
					comparisonKey: 'poPriceId',
					objectList: [{
						poPriceId: 'overStdPrice',
						poPrice: 'Over Standard Price'
					}, {
						poPriceId: 'notOverStdPrice',
						poPrice: 'Equal to or Below Standard Price'
					}]
				},
				'POStatus': {
					id: 'poStatus',
					displayName: 'Confirmation Status',
					label: 'display',
					comparisonKey: 'poStatus',
					objectList: [
						{ poStatus: 'confirmed', display: 'Confirmed' },
						{ poStatus: '-', display: 'Unconfirmed'}
					]
				},
				'ProfileType': {
					id: 'profileType',
					displayName: 'Privileges',
					label: 'profileTypeDisplay',
					comparisonKey: 'profileType',
					url: URLS.profileTypes,
					authz: ['filters', 'profile']
				},
				'ProjectArea': {
					id: 'projectArea',
					displayName: 'Area',
					label: 'projectArea',
					comparisonKey: 'projectArea',
					strip: true,
					url: String.format(URLS.projectAreas, globalConfig.factory.id),
					unformattedUrl: URLS.projectAreas + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectAreaChanged'
				},
				'ProjectCategories': {
					id: 'projectCategoryId',
					displayName: 'Category',
					label: 'projectCategoryName',
					comparisonKey: 'projectCategoryId',
					strip: true,
					url: String.format(URLS.projectCategories, globalConfig.factory.id),
					unformattedUrl: URLS.projectCategories + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectCategoryChanged',
					staticOption: [{
						'projectCategoryName': 'None',
						'projectCategoryId': '-1',
						'selected': true,
						'class': 'staticOption'
					}]
				},
				'ProjectGoals': {
					id: 'projectGoalId',
					displayName: 'Goal',
					label: 'projectGoalName',
					comparisonKey: 'projectGoalId',
					strip: true,
					url: String.format(URLS.projectGoals, globalConfig.factory.id),
					unformattedUrl: URLS.projectGoals + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					staticOption: [{
						'projectGoalName': 'None',
						'projectGoalId': '-1',
						'class': 'staticOption',
						'selectedByDefault': false
					}],
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectGoalChanged'
				},
				'ProjectManager': {
					id: 'projectManagerId',
					displayName: 'Project Manager',
					label: 'projectManagerDisplay',
					comparisonKey: 'projectManagerId',
					url: String.format(URLS.projectManagers, globalConfig.factory.id),
					unformattedUrl: URLS.projectManagers + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectManagerChanged'
				},
				'ProjectMember': {
					id: 'projectMemberId',
					displayName: 'Involved',
					label: 'responsibleName',
					comparisonKey: 'userNdx',
					url: String.format(URLS.responsibleUsers, globalConfig.factory.id),
					unformattedUrl: URLS.responsibleUsers,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'leanProjects']
				},
				'ProjectStage': {
					id: 'stageId',
					displayName: 'Stage',
					label: 'name',
					comparisonKey: 'id',
					url: String.format(URLS.projectStages, globalConfig.factory.id) + '?staticOnly=true',
					unformattedUrl: URLS.projectStages + '?staticOnly=true&grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					sendAllValues: true,
					authz: ['filters', 'leanProjects']
				},
				'ProjectStageAll': {
					id: 'projectStageId',
					displayName: 'Stage',
					label: 'name',
					comparisonKey: 'id',
					url: String.format(URLS.projectStages, globalConfig.factory.id),
					unformattedUrl: URLS.projectStages + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					authz: ['filters', 'leanProjects']
				},
				'ProjectStageNoStatic': {
					id: 'stageIdNoStatic',
					displayName: 'Stage',
					label: 'name',
					comparisonKey: 'id',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					url: String.format(URLS.projectStages, globalConfig.factory.id) + '?dynamicOnly=true',
					unformattedUrl: URLS.projectStages + '?dynamicOnly=true&grouped=true',
					authz: ['filters', 'leanProjects']
				},
				'ProjectStageWithArchive': {
					id: 'stageIdWithArchive',
					displayName: 'Stage',
					label: 'name',
					comparisonKey: 'id',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					url: String.format(URLS.projectStages, globalConfig.factory.id) + '?dynamicOnlyWithArchive=true',
					unformattedUrl: URLS.projectStages + '?dynamicOnlyWithArchive=true&grouped=true',
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectStageChanged'
				},
				'ProjectStageWithPendingApproval': {
					id: 'stageIdWithPendingApproval',
					displayName: 'Stage',
					label: 'name',
					comparisonKey: 'id',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					url: String.format(URLS.projectStages, globalConfig.factory.id) + '?dynamicOnlyWithPending=true',
					unformattedUrl: URLS.projectStages + '?dynamicOnlyWithPending=true&grouped=true',
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectStageChanged'
				},
				'ProjectTaskStatus': {
					id: 'taskStatus',
					displayName: 'Status',
					label: 'taskStatus',
					comparisonKey: 'taskStatus',
					objectList: [{
						'taskStatus': 'Pending'
					}, {
						'taskStatus': 'Started'
					}, {
						'taskStatus': 'Completed'
					}]
				},
				'UnreadMessages': {
					id: 'chatHasUnreadMessage',
					displayName: 'Chat (unread)',
					label: 'display',
					comparisonKey: 'hasUnread',
					type: 'singleSelect',
					objectList: [{
						'hasUnread': 1,
						'display': 'Unread Messages'
					},{
						'hasUnread': 'LEANDNA_NONE',
						'display': 'All Results'
					}]
				},
				'ChatWatched': {
					id: 'chatWatchedByCurrentUser',
					displayName: 'Chat (watched)',
					label: 'display',
					comparisonKey: 'isWatched',
					type: 'singleSelect',
					objectList: [{
						'isWatched': 1,
						'display': 'Show watched'
					},{
						'isWatched': 'LEANDNA_NONE',
						'display': 'Show all'
					}]
				},
				'ProjectTypes': {
					id: 'projectType',
					displayName: 'Type',
					label: 'projectTypeName',
					comparisonKey: 'projectTypeName',
					url: String.format(URLS.projectTypes, globalConfig.factory.id),
					unformattedUrl: URLS.projectTypes + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectTypeChanged'
				},
				'ProjectBestPractice': {
					id: 'projectBestPractice',
					displayName: 'Best Practice',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'Yes',
						'value': 1
					}, {
						'label': 'No',
						'value': 0
					}]
				},
				'ProjectSavingsCategories': {
					id: 'projectSavingsCategoryId',
					displayName: 'Savings Category',
					label: 'name',
					comparisonKey: 'id',
					strip: true,
					url: String.format(URLS.projectSavingsCategories, globalConfig.factory.id) + '?excludeIncludeInTotal=false',
					unformattedUrl: URLS.projectSavingsCategories + '?excludeIncludeInTotal=false',
					updateOnFactory: true,
					noEscapeComma: true,
					authz: ['filters', 'leanProjects'],
					dashboardEventName: 'adfLeanProjectSavingsCategoryChanged',
					groupKey: 'includeInTotal',
					groupLabels: {
						true: $translate.instant('Included in totals'),
						false: $translate.instant('Not included in totals')
					}
				},
				'PurchaseDocumentType': {
					id: 'purchaseDocumentType',
					displayName: 'Purchase Document Type',
					label: 'purchaseDocumentType',
					comparisonKey: 'purchaseDocumentType',
					url: String.format(URLS.purchaseDocumentTypes, globalConfig.factory.id),
					unformattedUrl: URLS.purchaseDocumentTypes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					authz: ['filters', 'purchaseDocumentType']
				},
				'RiskCategory': {
					id: 'riskCategoryIds',
					displayName: 'Risk Category',
					label: 'label',
					comparisonKey: 'id',
					url: String.format(URLS.riskCategories, globalConfig.factory.id),
					unformattedUrl: URLS.riskCategories,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'riskCategoryIds'],
					operator: 'findinset',
					noEscapeComma: true
				},
				'RiskLevel': {
					id: 'aggregateRiskScoreLabel',
					displayName: 'Risk Level',
					label: 'aggregateRiskScoreLabel',
					comparisonKey: 'aggregateRiskScoreLabel',
					url: String.format(URLS.riskLevels, globalConfig.factory.id),
					unformattedUrl: URLS.riskLevels,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'aggregateRiskScoreLabel']
				},
				'SupplyDocumentType': {
					id: 'documentType',
					displayName: 'Supply Document Type',
					label: 'purchaseDocumentType',
					comparisonKey: 'purchaseDocumentType',
					url: String.format(URLS.purchaseDocumentTypes, globalConfig.factory.id),
					unformattedUrl: URLS.purchaseDocumentTypes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					useNotSelected: true,
					authz: ['filters', 'purchaseDocumentType']
				},
				'PurchaseDocumentTypeForReceipts': {
					id: 'purchaseDocumentTypeForReceipts',
					displayName: 'Purchase Document Type',
					label: 'purchaseDocumentType',
					comparisonKey: 'purchaseDocumentType',
					url: String.format(URLS.purchaseDocumentTypes, globalConfig.factory.id) + '?receipts=1',
					unformattedUrl: URLS.purchaseDocumentTypes + '?receipts=1',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'purchaseDocumentType']
				},
				'InventoryState': {
					id: 'state',
					displayName: 'State',
					label: 'stateLabel',
					comparisonKey: 'state',
					objectList: [{
						state: 'Blocked',
						stateLabel: 'Blocked'
					}, {
						state: 'Unrestricted',
						stateLabel: 'Unrestricted'
					}]
				},
				'RecommendedOrderPolicy': {
					id: 'analysisReplenishmentType',
					displayName: 'Recommended Order Policy',
					label: 'analysisReplenishmentType',
					comparisonKey: 'analysisReplenishmentType',
					url: String.format(URLS.analysisReplenishmentTypes, globalConfig.factory.id),
					unformattedUrl: URLS.analysisReplenishmentTypes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: ['filters', 'analysisReplenishmentType']
				},
				'ResolutionType': {
					id: 'resolutionType',
					displayName: 'Scope',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Plant',
						'value': 'Plant'
					}, {
						'name': 'Value Stream',
						'value': 'ValueStream'
					}]
				},
				'Responsible': {
					id: 'responsibleNdx',
					displayName: 'Task Responsible',
					label: 'responsibleName',
					comparisonKey: 'userNdx',
					url: String.format(URLS.responsibleUsers, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.responsibleUsers,
					staticOption: [{
						'responsibleName': 'My Tasks (' + globalConfig.user.firstName + ' ' + globalConfig.user.lastName + ')',
						'userNdx': globalConfig.user.id,
						'class': 'staticOption',
						'excludeMatchingOption': true
					}],
					authz: ['filters', 'user'],
					dashboardEventName: 'adfActionResponsibleChanged'
				},
				'ResponsibleCategory': {
					id: 'cmtRspCmt',
					displayName: 'Responsible',
					label: 'resDisplay',
					comparisonKey: 'resVal',
					url: String.format(URLS.responsibleCategories, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.responsibleCategories,
					staticOption: [{
						'resDisplay': 'None',
						'resVal': 'LEANDNA_NONE'
					}],
					authz: ['filters', 'responsibleCategory']
				},
				'ShortagePriority': {
					id: 'cmtColorCmt',
					displayName: 'Priority',
					label: 'colorDisplay',
					comparisonKey: 'colorVal',
					objectList: [{
						'colorDisplay': 'None',
						'colorVal': 'LEANDNA_NONE'
					}, {
						'colorDisplay': 'Red',
						'colorVal': 'color-code-10-red'
					}, {
						'colorDisplay': 'Blue',
						'colorVal': 'color-code-20-blue'
					}, {
						'colorDisplay': 'Yellow',
						'colorVal': 'color-code-30-yellow'
					}],
					authz: []
				},
				'SmeCertified': {
					id: 'isSmeCertified',
					displayName: 'SME Certified',
					label: 'display',
					comparisonKey: 'value',
					objectList: [
						{ display: 'Yes', value: 1 },
						{ display: 'No', value: 0 }
					]
				},
				'WorkbenchSupervisor': {
					id: 'isWorkbenchSupervisor',
					displayName: 'Workbench Supervisor',
					label: 'display',
					comparisonKey: 'value',
					objectList: [
						{ display: 'Yes', value: 1 },
						{ display: 'No', value: 0 }
					]
				},
				'CanAccessKei': {
					id: 'canAccessKei',
					displayName: 'Can use Kei',
					label: 'display',
					comparisonKey: 'value',
					objectList: [
						{ display: 'Yes', value: 1 },
						{ display: 'No', value: 0 }
					]
				},
				'CanAccessIOP': {
					id: 'canAccessIOP',
					displayName: 'Inventory optimization access',
					label: 'display',
					comparisonKey: 'value',
					objectList: [
						{ display: 'Yes', value: 1 },
						{ display: 'No', value: 0 }
					]
				},
				'SpecialProcurementType': {
					id: 'specialProcurementType',
					displayName: 'Special Procurement Type',
					label: 'description',
					comparisonKey: 'specialProcurementType',
					url: String.format(URLS.specialProcurementTypes, globalConfig.factory.id),
					unformattedUrl: URLS.specialProcurementTypes,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					authz: [],
					optionMap: function (item) {
						if (item.specialProcurementType === 'UndefinedProcurementType') {
							item.description = '-';
						} else {
							item.description = item.specialProcurementType;
						}
						return item;
					}
				},
				'RoleType': {
					id: 'role',
					displayName: 'Role',
					label: 'name',
					comparisonKey: 'roleType',
					url: URLS.roles,
					authz: ['filters', 'role']
				},
				'SBOOperationsNumbers': {
					id: 'operationsNumber',
					displayName: 'Operations Number',
					label: 'operationsNumber',
					comparisonKey: 'operationsNumber',
					url: String.format(URLS.sboOperationsNumbers, globalConfig.factory.id),
					unformattedUrl: URLS.sboOperationsNumbers,
					authz: ['filters', 'operationsNumbers'],
					updateOnFactory: true,
					storeFactoryNdxs: true
				},
				'SBORequirementTypes': {
					id: 'requirementType',
					displayName: 'Requirement Type',
					label: 'requirementType',
					comparisonKey: 'requirementType',
					url: String.format(URLS.sboRequirementTypes, globalConfig.factory.id),
					unformattedUrl: URLS.sboRequirementTypes,
					authz: ['filters', 'requirementType'],
					updateOnFactory: true,
					storeFactoryNdxs: true
				},
				'SBOWorkcenters': {
					id: 'workcenter',
					displayName: 'Workcenter',
					label: 'workcenter',
					comparisonKey: 'workcenter',
					url: String.format(URLS.sboWorkcenters, globalConfig.factory.id),
					unformattedUrl: URLS.sboWorkcenters,
					authz: ['filters', 'workcenter'],
					updateOnFactory: true,
					storeFactoryNdxs: true
				},
				'ShortageCriticalityLevel': {
					id: 'shortageCriticalityLevelId',
					displayName: 'Criticality Level',
					label: 'label',
					comparisonKey: 'id',
					url: String.format(URLS.shortageCriticalityLevels, globalConfig.factory.id),
					unformattedUrl: URLS.shortageCriticalityLevels,
					updateOnFactory: true,
					noEscapeComma: true,
					staticOption: [{
						id: -1,
						label: 'Non Critical'
					}],
					auth: ['filters', 'shortageCriticalityLevels'],
					alternateComparisonKey: ['label']
				},
				'SpendType': {
					id: 'spendType',
					displayName: 'Spend Type',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'Direct',
						'value': 'direct'
					}, {
						'label': 'Indirect',
						'value': 'indirect'
					}]
				},
				'StorageType': {
					id: 'storageType',
					displayName: 'Storage Type',
					label: 'storageType',
					comparisonKey: 'storageType',
					url: String.format(URLS.storageTypes, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.storageTypes,
					undefinedMap: JSON.stringify({'UndefinedStorageType' : 'Storage Type Not Defined'}),
					authz: ['filters', 'storageType']
				},
				'Supplier': {
					id: 'supplierNdx',
					displayName: 'Supplier',
					label: 'supplierName',
					comparisonKey: 'supplierNdx',
					url: String.format(URLS.suppliers, globalConfig.factory.id),
					unformattedUrl: URLS.suppliers + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					useNotSelected: true,
					alternateKey: 'supplierCode',
					authz: ['filters', 'supplier'],
					dashboardEventName: 'adfSupplierChanged'
				},
				'SupplierByAdminAccess': {
					id: 'supplierNdx',
					displayName: 'Supplier',
					label: 'supplierName',
					comparisonKey: 'supplierNdx',
					url: String.format(URLS.suppliers, userAdminSites || globalConfig.factory.id) + '?grouped=true',
					storeFactoryNdxs: true,
					noEscapeComma: true,
					useNotSelected: true,
					alternateKey: 'supplierCode',
					authz: ['filters', 'supplier'],
					dashboardEventName: 'adfSupplierChanged'
				},
				'TaskCategory': {
					id: 'taskCategory',
					displayName: 'Task Category',
					label: 'displayName',
					comparisonKey: 'name',
					url: String.format(URLS.taskCategories, globalConfig.factory.id),
					unformattedUrl: URLS.taskCategories + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					staticOption: [{
						'name': 'None',
						'displayName': 'None'
					}],
					authz: ['filters', 'task'],
					dashboardEventName: 'adfTaskCategoryChanged'
				},
				'TaskStatus': {
					id: 'taskStatus',
					displayName: 'Task Status',
					label: 'name',
					comparisonKey: 'value',
					url: String.format(URLS.taskStatuses, globalConfig.factory.id),
					unformattedUrl: URLS.taskStatuses + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					staticOption: [{
						'name': 'None',
						'value': 'None',
						'selectedByDefault': false
					}],
					authz: ['filters', 'task'],
					dashboardEventName: 'adfTaskStatusChanged'
				},
				'TaskStatusDefaultAll': {
					id: 'taskStatus',
					displayName: 'Task Status',
					label: 'name',
					comparisonKey: 'value',
					url: String.format(URLS.taskStatuses, globalConfig.factory.id),
					storeFactoryNdxs: true,
					staticOption: [{
						'name': 'None',
						'value': 'None'
					}],
					authz: ['filters', 'task']
				},
				'TaskStatusWithArchived': {
					id: 'taskStatus',
					displayName: 'Task Status',
					label: 'name',
					comparisonKey: 'value',
					sendAllValues: true,
					url: String.format(URLS.taskStatuses, globalConfig.factory.id),
					staticOption: [{
						'name': 'Show Archived',
						'value': 'Show Archived',
						'id': '-1',
						'alternateParam': 'showArchived',
						'class': 'staticOption',
						'selectedByDefault': false
					}],
					authz: ['filters', 'task']
				},
				'ValueStream': {
					id: 'valueStream',
					displayName: 'Value Stream',
					label: 'name',
					comparisonKey: 'ndx',
					url: String.format(URLS.valueStreams, globalConfig.factory.id),
					unformattedUrl: URLS.valueStreams + '?grouped=true',
					updateOnFactory: true,
					storeFactoryNdxs: true,
					noEscapeComma: true,
					staticOption: [{
						'name': 'Plant-wide',
						'ndx': 0,
						'class': 'staticOption'
					}],
					authz: ['filters', 'valueStream'],
					dashboardEventName: 'adfValueStreamChanged'
				},
				'ValueStreamWithPerf': {
					id: 'valueStreamWithPerf',
					displayName: 'Value Stream',
					label: 'name',
					comparisonKey: 'ndx',
					url: String.format(URLS.valueStreamsWithPerf, globalConfig.factory.id),
					unformattedUrl: URLS.valueStreamsWithPerf,
					storeFactoryNdxs: true,
					staticOption: [{
						'name': 'Plant-wide',
						'ndx': 0,
						'class': 'staticOption'
					}],
					authz: ['filters', 'valueStream'],
					updateOnFactory: true
				},
				'InventoryActionType': {
					id: 'inventoryActionType',
					displayName: 'Action Type',
					label: 'name',
					comparisonKey: 'value',
					url: String.format(URLS.inventoryActionTypes, globalConfig.factory.id),
					authz: ['filters', 'inventoryActionType']
				},
				'WorkerState': {
					id: 'workerState',
					displayName: 'State',
					label: 'state',
					comparisonKey: 'state',
					objectList: [{
						'state': 'SUCCESSFUL'
					}, {
						'state': 'FAILED'
					}, {
						'state': 'WAITING'
					}, {
						'state': 'RUNNING'
					}, {
						'state': 'UNKNOWN'
					}]
				},
				'WorkerType': {
					id: 'workerType',
					displayName: 'Type',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'Analytics Engine',
						'value': 'Procurement'
					}, {
						'label': 'LeanDNA Connect',
						'value': 'LeanDNA Connect'
					}, {
						'label': 'LeanLoad',
						'value': 'LeanLoad'
					}, {
						'label': 'LeanSync',
						'value': 'LeanSync'
					}, {
						'label': 'LeanTransform',
						'value': 'LeanTransform'
					}]
				},
				'ExcessType': {
					id: 'excessType',
					displayName: 'Excess Type',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'Excess Inventory',
						'value': 'excess'
					}, {
						'name': 'Obsolete Inventory',
						'value': 'obsolete'
					}]
				},
				'UnableToFixCategory': {
					id: 'unableToFixCategoryNdx',
					displayName: 'Unable to Fix Category',
					label: 'categoryName',
					comparisonKey: 'ndx',
					url:  String.format(URLS.inventoryActionUnableToFixCategories, globalConfig.factory.id),
					authz: ['filters']
				},
				'CustomersForUser': {
					id: 'customerNdx',
					displayName: 'Customer',
					label: 'name',
					comparisonKey: 'ndx',
					url: String.format(URLS.customerSuccessCustomers, globalConfig.factory.id) + '?excludePilotSite=false&limitToUser=' + (globalConfig.user.isCustomerAdministrator && globalConfig.user.profileType !== 'SuperSystemAdministrator'),
					staticOption: [{
						'name': 'None',
						'ndx': 'LEANDNA_NONE',
						'selectedByDefault': false
					}]
				},
				'FixedCategory': {
					id: 'fixReason',
					displayName: 'Fixed Category',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': 'POs',
						'value': 'POs'
					}, {
						'name': 'Requirements',
						'value': 'Requirements'
					}, {
						'name': 'Cost Per Item',
						'value': 'Cost Per Item'
					}, {
						'name': 'On Hand',
						'value': 'On Hand'
					}, {
						'name': 'Mixed',
						'value': 'Mixed'
					}]
				},

				// single select filters
				'AlertType': {
					id: 'alert',
					displayName: 'Alert Type',
					type: 'singleSelect',
					label: 'display',
					comparisonKey: 'alertType',
					disabled: false,
					removable: false,
					objectList: [{
						'alertType': 'EarlyDelivery',
						'display': 'Email - Early Delivery'
					}, {
						'alertType': 'POToAction',
						'display': 'Email - PO to Action'
					}, {
						'alertType': 'POOverStdPrice',
						'display': 'Email - PO Over Standard Price'
					}, {
						'alertType': 'VMIOverMax',
						'display': 'Email - MinMax Over Max'
					}, {
						'alertType': 'StandardBuyerWork',
						'display': 'Email - Standard Work'
					}, {
						'alertType': 'DataSyncConfirmation',
						'display': 'Email - Data Sync Confirmation'
					}, {
						'alertType': 'DataSyncFailure',
						'display': 'Email - Data Sync Failure'
					}]
				},
				'BaselinePrice': {
					id: 'baselinePrice',
					displayName: 'Baseline Price',
					type: 'singleSelect',
					label: 'label',
					comparisonKey: 'value',
					setDefaultValue: true,
					objectList: [{
						'label': 'Standard Price',
						'value': 'standardPrice'
					}, {
						'label': 'Last FY PO Price',
						'value': 'indexedPrice'
					}]
				},
				'BucketType': {
					id: 'bucketType',
					displayName: 'Bucket Type',
					type: 'singleSelect',
					label: 'name',
					comparisonKey: 'value',
					removable: true,
					objectList: [{
						'name': 'Weeks',
						'value': 'weeks'
					}, {
						'name': 'Months',
						'value': 'months'
					}, {
						'name': 'Days',
						'value': 'days'
					}],
					sendAllValues: true
				},
				'Control Tower Time Period': {
					id: 'controlTowerTimePeriod',
					displayName: 'Time Period',
					label: 'timePeriod',
					comparisonKey: 'value',
					disabled: false,
					type: 'singleSelect',
					objectList: [{
						'timePeriod': $translate.instant('Current Fiscal Year'),
						'value': 'Current'
					},
					{
						'timePeriod': $translate.instant('Next Fiscal Year'),
						'value': 'Next'
					},
					{
						'timePeriod': $translate.instant('Previous Fiscal Year'),
						'value': 'Previous'
					},
					{
						'timePeriod': $translate.instant('Year Before Previous Fiscal Year'),
						'value': 'YearBeforePrevious'
					},
					{
						'timePeriod': $translate.instant('Last 4 Weeks'),
						'value': '4 Weeks'
					},
					{
						'timePeriod': $translate.instant('Last 12 Weeks'),
						'value': '12 Weeks'
					},
					{
						'timePeriod': $translate.instant('Last 26 Weeks'),
						'value': '26 Weeks'
					},
					{
						'timePeriod': $translate.instant('Last 4 Weeks and Next 12 Weeks'),
						'value': 'Last 4 And Next 12 Weeks'
					}],
					dashboardEventName: 'adfControlTowerTimePeriodChanged',
					removable: false
				},
				'DaysBack': {
					id: 'daysBack',
					displayName: 'Time Period',
					type: 'singleSelect',
					label: 'timePeriodName',
					comparisonKey: 'value',
					objectList: [{
						'timePeriodName': $translate.instant('90 Days Back'),
						'value': '-90'
					}, {
						'timePeriodName': $translate.instant('180 Days Back'),
						'value': '-180'
					}]
				},
				'IsBlanketOrder': {
					id: 'isBlanketOrder',
					displayName: 'Is blanket order',
					type: 'multiSelect',
					label: 'name',
					comparisonKey: 'value',
					objectList: [
						{ 'name': $translate.instant('Yes'), 'value': true},
						{ 'name': $translate.instant('No'), 'value': false}
					]
				},
				'FiscalYear': {
					id: 'fiscalYear',
					displayName: 'Fiscal Year',
					type: 'singleSelect',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'Current',
						'value': 'current'
					}, {
						'label': 'Previous',
						'value': 'previous'
					}]
				},
				'FiscalYearList': {
					id: 'fy',
					displayName: 'Fiscal Year',
					type: 'singleSelect',
					label: 'fy',
					comparisonKey: 'fy',
					url: String.format(URLS.fiscalYears, globalConfig.factory.id),
					unformattedUrl: URLS.fiscalYears,
					noEscapeComma: true,
					useNotSelected: true,
					alternateKey: 'isCurrent',
					authz: ['filters', 'fiscalYearList'],
					updateOnFactory: true
				},
				'InventoryActionReportTimePeriod': {
					id: 'inventoryActionReportTimePeriod',
					displayName: 'Time Period',
					type: 'singleSelect',
					label: 'name',
					comparisonKey: 'value',
					removable: false,
					objectList: [{
						'name': 'Year To Date',
						'value': 'ytd'
					}, {
						'name': 'Currently Active',
						'value': 'active'
					}]
				},
				'MoveInForRequirement': {
					id: 'isMoveInForRequirement',
					displayName: 'Move in for requirement',
					type: 'singleSelect',
					label: 'name',
					comparisonKey: 'value',
					objectList: [
						{ 'name': $translate.instant('Yes'), 'value': 1},
						{ 'name': $translate.instant('No'), 'value': 0}
					]
				},
				'Multi Factory': {
					id: 'multiFactory',
					displayName: 'Multi Site',
					label: 'description',
					comparisonKey: 'value',
					url: String.format(URLS.multiFactory, globalConfig.factory.id),
					unformattedUrl: URLS.multiFactory,
					updateOnFactory: true,
					useNotSelected: true,
					type: 'singleSelect',
					authz: ['filters', 'multiFactory'],
					dashboardEventName: 'adfMultiFactoryChanged'
				},
				'OutsideLeadTimeOnly': {
					id: 'outsideLeadTimeOnly',
					displayName: 'Lead Time',
					type: 'singleSelect',
					label: 'display',
					comparisonKey: 'showOutsideOnly',
					disabled: false,
					objectList: [{
						'showOutsideOnly': false,
						'display': 'All POs'
					}, {
						'showOutsideOnly': true,
						'display': 'Outside Lead Time'
					}],
					dashboardEventName: 'adfLeadTimeChanged'
				},
				'PotentialSavingsSort': {
					id: 'potentialSavingsSort',
					displayName: 'Sort',
					label: 'display',
					comparisonKey: 'id',
					type: 'singleSelect',
					removable: false,
					objectList: [{
						'id': 'potentialSavings',
						'display': 'Potential Savings'
					}, {
						'id': 'createdDate',
						'display': 'Created Date'
					}]
				},
				'ProjectTaskDueDate': {
					id: 'taskDueDate',
					displayName: 'Due Date',
					label: 'taskDueDate',
					comparisonKey: 'id',
					type: 'singleSelect',
					objectList: [{
						id: 'All',
						'taskDueDate': 'All'
					}, {
						id: '0',
						'taskDueDate': 'Late'
					}, {
						id: '7',
						'taskDueDate': 'Next 7 Days'
					}, {
						id: '30',
						'taskDueDate': 'Next 30 Days'
					}]
				},
				'ProjectSavings': {
					id: 'projectSavings',
					displayName: 'Savings View',
					label: 'projectSavings',
					comparisonKey: 'projectSavings',
					type: 'singleSelect',
					updateOnFactory: true,
					objectList: [{
						'projectSavings': 'Actual Total Savings'
					}, {
						'projectSavings': 'Target Total Savings'
					}, {
						'projectSavings': 'Weighted Target Savings'
					}]
				},
				'showFirstOrder': {
					id: 'showFirstOrder',
					displayName: 'Orders Shown',
					type: 'singleSelect',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'All Orders',
						'value': false
					}, {
						'label': 'First Order Only',
						'value': true
					}]
				},
				'showOnlyCriticalSuppliers': {
					id: 'showOnlyCriticalSuppliers',
					displayName: 'Critical Suppliers',
					type: 'singleSelect',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						'label': 'All Suppliers',
						'value': false
					}, {
						'label': 'Critical Only',
						'value': true
					}]
				},
				'ViewByEntitySite': {
					id: 'viewByEntityOrSite',
					displayName: 'View By',
					label: 'viewBy',
					comparisonKey: 'viewBy',
					type: 'singleSelect',
					objectList: [{
						viewBy: 'Entity'
					}, {
						viewBy: 'Site'
					}]
				},
				'ViewByCustomerEntitySite': {
					id: 'viewByCustomerOrEntityOrSite',
					displayName: 'View By',
					label: 'viewBy',
					comparisonKey: 'viewBy',
					type: 'singleSelect',
					objectList: [{
						viewBy: 'Customer'
					},{
						viewBy: 'Entity'
					}, {
						viewBy: 'Site'
					}]
				},
				'ViewByBuDivisionEntitySite': {
					id: 'viewByBuDivisionEntitySite',
					displayName: 'View By',
					label: 'display',
					comparisonKey: 'viewBy',
					type: 'singleSelect',
					objectList: [{
						display: 'Business Unit',
						viewBy: 'businessUnit'
					},{
						display: 'Division',
						viewBy: 'division'
					},{
						display: 'Entity',
						viewBy: 'entity'
					}, {
						display: 'Site',
						viewBy: 'site'
					}]
				},

				// string filters
				'ParentAssembly': {
					id: 'parentAssembly',
					displayName: 'Parent Assembly',
					type: 'string',
					authz: ['filters', 'parentAssembly']
				},
				'ProductionOrder': {
					id: 'productionOrder',
					displayName: 'Production Order',
					type: 'string'
				},
				'PurchaseOrderNumber': {
					id: 'purchaseOrderNumber',
					displayName: 'PO Number',
					type: 'string'
				},
				'SupplyOrderNumber': {
					comparisonKey: 'orderNumber',
					id: 'supplyOrderNumber',
					displayName: 'SUPPLY_ORDER_NUMBER',
					type: 'string'
				},

				// numerical filters
				'DaysCoverage': {
					id: 'daysCoverage',
					displayName: 'Days Coverage',
					type: 'numerical'
				},
				'DaysInShortage': {
					id: 'daysInShortage',
					displayName: 'Days In Shortage',
					type: 'numerical'
				},
				'CTBShortageImpactedValue': {
					id: 'ctbShortageImpactedValue',
					displayName: 'CTB Shortage Impacted Value',
					type: 'numerical'
				},
				'CTBImpactedOrdersSingleShortageCount': {
					id: 'ctbImpactedOrdersSingleShortageCount',
					displayName: 'CTB Impacted Orders (as single shortage)',
					type: 'numerical'
				},
				'DaysOnHand': {
					id: 'daysOnHand',
					displayName: 'Days on Hand',
					type: 'numerical'
				},
				'ClearToBuildQuantity': {
					id: 'quantityInClearToBuildWindow',
					displayName: 'Qty in LOB supply exclusion window',
					type: 'numerical'
				},
				'DaysUntilPOFirm': {
					id: 'daysUntilPOFirm',
					displayName: 'Days Until Firm',
					type: 'numerical'
				},
				'DaysUntilProcurementLeadTime': {
					id: 'daysUntilProcurementLeadTime',
					displayName: 'Days Until Procurement Lead Time',
					type: 'numerical'
				},
				'LeadTimeMultiple': {
					id: 'analysisMultipleLeadTimeFloat',
					displayName: 'Lead Time Multiple',
					type: 'numerical'
				},
				'MonthlyRequirement': {
					id: 'analysisAvgDailyDemandFloat',
					displayName: 'Company Defined Demand (Monthly)',
					type: 'numerical'

				},
				'OnOrderNext90Days': {
					id: 'next90Days',
					displayName: 'Next 90 Days',
					type: 'numerical'
				},
				'OnOrderQty': {
					id: 'remainingQuantityFloat',
					displayName: 'Remaining Qty',
					type: 'numerical'
				},
				'PlannedOnOrderQuantity': {
					id: 'plannedOnOrderQuantity',
					displayName: 'Planned On Order Qty',
					type: 'numerical'
				},
				'FirmedOnOrderQuantity': {
					id: 'firmedOnOrderQuantity',
					displayName: 'Firmed On Order Qty',
					type: 'numerical'
				},
				'POs To Action: Next 90 Days': {
					id: 'poToCancelNext90Days',
					displayName: 'POs To Action: Next 90 Days',
					type: 'numerical'
				},
				'DepthOfDelay': {
					id: 'depthOfDelay',
					displayName: 'Depth of Delay',
					type: 'numerical'
				},
				'AgeOfPoAction': {
					id: 'ageOfPoAction',
					displayName: 'Age of PO Actions',
					type: 'numerical'
				},
				'ImpactedOrdersCount': {
					id: 'impactedOrdersCount',
					displayName: 'Impacted Orders Count',
					type: 'numerical'
				},
				'TotalShortageOccurrences': {
					id: 'totalShortageOccurrences',
					displayName: 'Total Shortage Occurrences',
					type: 'numerical'
				},
				'NumDaysAsAShortage': {
					id: 'numDaysAsAShortage',
					displayName: 'Number of Days as a Shortage',
					type: 'numerical'
				},
				'AverageDaysInShortage': {
					id: 'averageDaysInShortage',
					displayName: 'Average Days in Shortage',
					type: 'numerical'
				},
				'MaxDaysInShortage': {
					id: 'maxDaysInShortage',
					displayName: 'Max Days in Shortage',
					type: 'numerical'
				},
				'AggregateRiskScore': {
					id: 'aggregateRiskScore',
					displayName: 'Aggregate Risk Score',
					type: 'numerical'
				},
				'TaskCount': {
					id: 'taskCount',
					displayName: 'Task Count',
					type: 'numerical'
				},

				// date filters
				'ActualReceiptDate': {
					id: 'actualReceiptDate',
					displayName: 'Actual Receipt Date',
					type: 'date'
				},
				'CompletedDate': {
					id: 'dateCompleted',
					displayName: 'Completed Date',
					type: 'date'
				},
				'TaskCompletedDate': {
					id:  'actionCompletedDate',
					displayName: 'Completed Date',
					type: 'date'
				},
				'CurrentDate': {
					id: 'currentDate',
					displayName: 'Date',
					type: 'date'
				},
				'CreationDate': {
					id: 'dateCreated',
					displayName: 'Created Date',
					type: 'date'
				},
				'ActionCreationDate': {
					id: 'actionDateCreated',
					displayName: 'Created Date',
					type: 'date'
				},
				'ActionDueDate': {
					id: 'actionDueDate',
					displayName: 'Task Due Date',
					type: 'date'
				},
				'ConfirmDate': {
					id: 'confirmDate',
					displayName: 'Confirm Date',
					type: 'date'
				},
				'DateRequested': {
					id: 'dateRequest',
					displayName: 'Requested',
					type: 'date'
				},
				'DateStarted': {
					id: 'dateStart',
					displayName: 'Started',
					type: 'date'
				},
				'DateEnded': {
					id: 'dateEnd',
					displayName: 'Ended',
					type: 'date'
				},
				'DeliveryDate': {
					id: 'goldenSupplyDate',
					displayName: 'Expected Delivery Date',
					type: 'date'
				},
				'DeliveryDateSbo': {
					id: 'deliveryDate',
					displayName: 'Expected Delivery Date',
					type: 'date'
				},
				'FirstPoRequestedDate': {
					id: 'firstPurchaseOrderDate',
					displayName: 'Supply Order Expected Delivery Date',
					type: 'date'
				},
				'RequestedDate': {
					id: 'originalRequestedDate',
					displayName: 'Requested Date',
					type: 'date'
				},
				'FirstPoOriginalRequestedDate': {
					id: 'firstPurchaseOrderOriginalRequestedDate',
					displayName: 'Supply Order Requested Date',
					type: 'date'
				},
				'ScorecardDate': {
					id: 'scorecardDate',
					displayName: 'Scorecard Accountability Date',
					type: 'date'
				},
				'DueDate': {
					id: 'dueDate',
					displayName: 'Due Date',
					type: 'date'
				},
				'UseDate': {
					id: 'useDate',
					displayName: 'Date Used',
					type: 'date'
				},
				'LastActivity': {
					id: 'lastActivity',
					displayName: 'Last Activity',
					type: 'date'
				},
				'LogDate': {
					id: 'dateLog',
					displayName: 'Log Date',
					type: 'date'
				},
				'OrderCreationDate': {
					id: 'orderCreationDate',
					displayName: 'Creation Date',
					type: 'date'
				},
				'OrderDate': {
					id: 'orderDate',
					displayName: 'Order Date',
					type: 'date'
				},
				'POOnTimeFirmDate': {
					id: 'poOnTimeFirmDate',
					displayName: 'Order On Time Firm Date',
					type: 'date'
				},
				'PRCreationDate': {
					id: 'prCreationDate',
					displayName: 'PR Creation Date',
					type: 'date'
				},
				'PromiseDate': {
					id: 'promiseDate',
					displayName: 'Current Supplier Commit Date',
					type: 'date'
				},
				'OrderStartDate': {
					id: 'orderStartDate',
					displayName: 'Order Start Date',
					type: 'date'
				},
				'FirstImpactedOrderDate': {
					id: 'firstImpactedOrderDate',
					displayName: 'First Impacted Order Date',
					type: 'date'
				},
				'ShortageByOrderRequirementDate': {
					id: 'requirementDate',
					displayName: 'Requirement Date',
					type: 'date'
				},
				'ShortageByOrderProposedOnDockDate': {
					id: 'proposedOnDockDate',
					displayName: 'Proposed On-Dock Date',
					type: 'date'
				},
				'ShortageByOrderHistoryByCommitDateEditDate': {
					id: 'logDate',
					displayName: 'Edit Date',
					type: 'date'
				},
				'RequirementDate': {
					id: 'analysisRequirementDate',
					displayName: 'Earliest Demand Date',
					type: 'date'
				},
				'PrHistoryDate': {
					id: 'prHistoryDate',
					displayName: 'PR Log Date',
					type: 'date'
				},
				'Build Model Recommendation': {
					id: 'recommendedBuildModel',
					displayName: 'Build Model Recommendation',
					label: 'recommendedBuildModel',
					comparisonKey: 'recommendedBuildModel',
					objectList: [{
						'recommendedBuildModel': 'Build-to-Order'
					}, {
						'recommendedBuildModel': 'Build-to-Replenish'
					}, {
						'recommendedBuildModel': '-'
					}],
					authz: ['filters', 'recommendedBuildModel']
				},
				'StartMonth': {
					id: 'startMonth',
					displayName: 'Start Month',
					type: 'singleSelect',
					label: 'monthlyStartDate',
					comparisonKey: 'key',
					disabled: false,
					url: String.format(URLS.startMonths, globalConfig.factory.id),
					formatType: 'date',
					format: 'MMM yyyy',
					alternateKey: 'formattedDate'
				},
				'TimePeriod': getTimePeriodFilterObject('timePeriod', false),
				'SpendAnalyticsTimePeriod': getTimePeriodFilterObject('spendTimePeriod', true),
				'TimeSent': {
					id: 'timeSent',
					displayName: 'Time Sent',
					type: 'date'
				},
				'EmailDelivered': {
					id: 'wasDelivered',
					displayName: 'Delivered',
					label: 'display',
					comparisonKey: 'value',
					objectList: getYesNoObjectList()
				},
				'EmailBounced': {
					id: 'wasBounced',
					displayName: 'Bounced',
					label: 'display',
					comparisonKey: 'value',
					objectList: getYesNoObjectList()
				},
				'EmailRejected': {
					id: 'wasRejected',
					displayName: 'Rejected',
					label: 'display',
					comparisonKey: 'value',
					objectList: getYesNoObjectList()
				},
				'EmailComplained': {
					id: 'wasComplained',
					displayName: 'Marked spam',
					label: 'display',
					comparisonKey: 'value',
					objectList: getYesNoObjectList()
				},
				'EmailTags': {
					id: 'tag',
					displayName: 'Tag',
					label: 'tag',
					comparisonKey: 'tag',
					disabled: false,
					url: URLS.allEmailTags
				},
				'AuditLogObjectTypes': {
					id: 'objectType',
					displayName: 'Object Type',
					label: 'objectType',
					comparisonKey: 'objectType',
					url: URLS.allAuditLogObjectTypes
				},
				'AuditLogObjectId': {
					id: 'objectId',
					displayName: 'Object ID',
					type: 'numerical'
				},
				'Timestamp': {
					id: 'dateCreated',
					displayName: 'Timestamp',
					type: 'date'
				},
				'POPlacementTime': getCustomNumericalFilterObject('placementDaysLate', 'PO Placement Time',
					[{
						'label': $translate.instant('On Time'),
						'value': '0'
					}], 'Days Late', 'adfPOPlacementTimeChanged'),
				'DemandSimulation': {
					id: 'demandSimulation',
					displayName: 'Demand Simulation',
					type: 'demandSimulation',
					label: '',
					comparisonKey: 'value',
					isCustom: true,
					updateOnFactory: true,
					storeFactoryNdxs: true,
					url: String.format(URLS.endItems, globalConfig.factory.id),
					unformattedUrl: URLS.endItems,
					getDisplayRaw: function(value, objectList) {
						if (objectList && value && value.length) {
							var jsonObj = JSON.parse(value);
							return jsonObj.length + ' ' + $translate.instant('Deliveries');
						} else {
							return $translate.instant('None');
						}
					},
					getDisplayValue: function (value, objectList) {
						if (objectList && value) {
							var jsonObj = JSON.parse(value);
							var itemNdxs = _.map(jsonObj, 'itemNdx').toString().split(',');

							var itemCodes = _.map(_.filter(objectList, function (obj) {
								var masterList = obj['endItemNdx'].toString().split(',');
								return _.intersection(masterList, itemNdxs).length > 0;
							}), 'endItemCode');
							return itemCodes.toString();
						} else {
							return value;
						}
					}
				},
				'ShortageType': {
					id: 'shortageTypes',
					displayName: 'Shortage Types',
					label: 'label',
					comparisonKey: 'value',
					type: 'singleSelect',
					objectList: [{
						label: 'All shortages',
						value: 'all'
					}, {
						label: 'Only Critical Shortages',
						value: 'critical'
					}]
				},
				'MyItemsOnly': {
					id: 'myItemsOnly',
					displayName: 'My Items Only',
					type: 'string',
					dashboardEventName: 'adfBuyerChanged',
					excludeFromFilterList: true
				},
				'PRInsideLeadTime': {
					id: 'insideLeadTime',
					displayName: 'Inside Lead Time',
					label: 'display',
					comparisonKey: 'value',
					objectList: getYesNoObjectList()
				},
				'ClearToBuildPriority': {
					id: 'clearToBuildPriority',
					displayName: 'Clear to Build Priority',
					label: 'label',
					comparisonKey: 'value',
					objectList: [{
						label: 'Flagged',
						value: '1'
					}, {
						label: 'Unflagged',
						value: '0'
					}]
				},
				'InventoryActionReportingPeriod': {
					id: 'reportingPeriod',
					displayName: 'Reporting Period',
					label: 'label',
					url: String.format(URLS.inventoryActionReportingPeriod, globalConfig.factory.id),
					unformattedUrl: URLS.inventoryActionReportingPeriod,
					updateOnFactory: true,
					optionMap: function (reportingPeriod) {
						var components = reportingPeriod.value.split(';');
						var periodType = components[0];

						var label = '';
						if (periodType == 'm') {
							var targetDate = components[1];
							var formattedDate = $filter('date')(targetDate, 'MMM yyyy');
							label = formattedDate;
						} else {
							var fiscalPeriod = components[1];
							var fiscalYear = components[2];
							if (fiscalPeriod && fiscalPeriod.length > 0) {
								label = periodType.toUpperCase() + fiscalPeriod + ' ' + fiscalYear;
							}
						}
						reportingPeriod.label = label;
						return reportingPeriod;
					},
					comparisonKey: 'value'
				},
				'WhitelistedSuppliers' :
				{
					id: 'WhitelistedSuppliers',
					displayName: 'Whitelisted suppliers',
					type: 'singleSelect',
					label: 'name',
					comparisonKey: 'value',
					objectList: [{
						'name': $translate.instant('Whitelisted'),
						'value': '1'
					}, {
						'name': $translate.instant('Not whitelisted'),
						'value': '0'
					}]
				},
				'Approver': {
					comparisonKey: 'approver',
					id: 'approver',
					displayName: 'Approver',
					type: 'string'
				},
				'TasksWatchedBy': {
					id: 'watchedByUserNdx',
					displayName: 'Watched by',
					label: 'responsibleName',
					comparisonKey: 'userNdx',
					url: String.format(URLS.responsibleUsers, globalConfig.factory.id),
					updateOnFactory: true,
					storeFactoryNdxs: true,
					unformattedUrl: URLS.responsibleUsers,
					staticOption: [{
						'responsibleName': 'My watched tasks (' + globalConfig.user.firstName + ' ' + globalConfig.user.lastName + ')',
						'userNdx': globalConfig.user.id,
						'class': 'staticOption',
						'excludeMatchingOption': true
					}],
					authz: ['filters', 'user']
				}
			};
			filters = Object.assign(filters, flexFilters);
			filters = Object.assign(filters, customFieldsFilters);
			setDefaultFilterAttributes(filters);
			buildFactoryFilterModels(filters);
			return filters;
		}

		function setDefaultFilterAttributes(filters) {
			// set defaults for remaining attributes
			for (var filterName in filters) {
				if (filters.hasOwnProperty(filterName)) {
					var filter = filters[filterName];

					if (filter.type === undefined) {
						filter.type = 'multiselect';
					}
					if (filter.disabled === undefined) {
						filter.disabled = false;
					}
					if (filter.removable === undefined) {
						filter.removable = true;
					}
					if (filter.objectList === undefined &&
						(filter.type === 'multiselect' || filter.type === 'singleSelect')) {
						filter.objectList = [];
					}
					if (filter.selectedList === undefined && (filter.type === 'multiselect' || filter.type === 'singleSelect')) {
						filter.selectedList = [];
					}
					if (filter.unselectedList === undefined && (filter.type === 'multiselect' || filter.type === 'singleSelect')) {
						filter.unselectedList = [];
					}
					if (filter.authz === undefined) {
						filter.authz = [];
					}
					if (filter.type === 'numerical' || filter.type === 'date') {
						if (filter.comparator === undefined) {
							filter.comparator = '';
						}
						if (filter.valueOne === undefined) {
							filter.valueOne = '';
						}
						if (filter.valueTwo === undefined) {
							filter.valueTwo = '';
						}
						filter.isCustom = (filter.objectList !== undefined && filter.objectList.length > 0);
					} else if (filter.type === 'string' || filter.type === 'demandSimulation') {
						if (filter.isCustom === undefined) {
							filter.isCustom = false;
						}
						if (filter.value === undefined) {
							filter.value = '';
						}

						if (filter.type === 'demandSimulation' && filter.objectList === undefined) {
							filter.objectList = [];
						}
					}

					if (filter.dynamicWidth === undefined) {
						filter.dynamicWidth = false;
					}

					if (filter.isCaseSensitive === undefined) {
						filter.isCaseSensitive = true;
					}

					if (filter.checkMyItems === undefined) {
						filter.checkMyItems = false;
					}

					if (filter.excludeFromFilterList === undefined) {
						filter.excludeFromFilterList = false;
					}
				}
			}
		}


		function extractHierarchyElements(elementType, factories) {
			var fields = _.pull(['businessunit', 'division', 'entity'], elementType);
			return factories.reduce(function(items, factory) {
				var element = {};
				element[elementType] = factory[elementType];
				element['factory'] = [factory.ndx];
				fields.forEach(function(f) {
					element[f] = [factory[f]];
				});
				var i = _.findIndex(items, function(item) {
					return item[elementType] === element[elementType];
				});
				if (i === -1) {
					items.push(element);
				} else {
					items[i]['factory'].push(element.factory[0]);
					fields.forEach(function(f) {
						items[i][f] = _.union(items[i][f], element[f]);
					});
				}
				return _.sortBy(items, [elementType]);
			}, []);
		}

		function setQueryParam(id, qParamList, value, valueOne, valueTwo, leaveDecoded, type) {
			if (value && value !== '') {
				var obj = { 'key': id };
				if (value !== 'custom') {
					obj.value = value;
				} else {
					var startDate = valueOne;
					var endDate = valueTwo;
					if (valueOne > valueTwo) {
						startDate = valueTwo;
						endDate = valueOne;
					}

					var filter = {
						'startDate': startDate,
						'endDate': endDate
					};
					obj.value = leaveDecoded ? JSON.stringify(filter).replace(/\"/g, '\'') : encodeURIComponent(JSON.stringify(filter));
				}
				qParamList.push(obj);
			}
		}

		function buildFactoryFilterModels(filters) {
			// FactoryHierarchy Filters
			var hierarchyFilters = ['businessunit', 'division', 'entity'];

			var factories, filter,
				factoryFilter = filters['Factory'],
				customerNdx = globalConfig.customer.id;
			var isSupplier = globalConfig.user.role === 'Supplier';

			factories = _.toArray(globalConfig.user.authFacts).filter(function(factory) {
				return (isSupplier ? factory.roleType === 'Supplier' : factory.roleType !== 'Supplier') && factory.customerNdx === customerNdx;
			});

			factoryFilter.masterObjectList = factories.map(function(factory) {
				return {
					id: factory.ndx,
					name: factory.name,
					alias: factory.alias || factory.name,
					businessunit: factory.businessunit,
					division: factory.division,
					entity: factory.entity,
					dataSyncIssue: factory.dataSyncIssue
				};
			}).sort(function(a, b) {
				if (a.id === globalConfig.factory.id)
					return -1;
				if (b.id === globalConfig.factory.id)
					return 1;
				if (a.alias < b.alias)
					return -1;
				if (a.alias > b.alias)
					return  1;
				return 0;
			});
			factoryFilter.objectList = _.clone(factoryFilter.masterObjectList);

			hierarchyFilters.forEach(function(filterId) {
				filter = _.find(filters, { id: filterId });
				if (filter) {
					filter.masterObjectList = extractHierarchyElements(filterId, factories);
					filter.objectList = _.clone(filter.masterObjectList);
				}
			});
		}

		function clearSelectedAndUnselected() {
			var filters = getFilterDefinitions();
			for (var filterName in filters) {
				var filter = filters[filterName];
				if (filter.type === 'multiselect' || filter.type === 'singleSelect') {
					filter.selectedList.length = 0;
					filter.unselectedList.length = 0;
				}
			}
		}

		function getValidTimePeriodValue(filterValue, listOfValidTimePeriods) {
			if (filterValue) {
				return _.find(listOfValidTimePeriods, {value: filterValue}) ? filterValue : 'current';
			} else {
				return 'current';
			}
		}

		function getYesNoObjectList() {
			return [{
				value: '1',
				display: 'Yes'
			}, {
				value: '0',
				display: 'No'
			}];
		}

		function getTimePeriodFilterObject(id, isCustomDaysBack) {
			return {
				id: id || 'timePeriod',
				displayName: 'Time Period',
				type: 'date',
				label: 'timePeriodName',
				comparisonKey: 'value',
				objectList: [{
					'timePeriodName': $translate.instant('All'),
					'value': 'all'
				}, {
					'timePeriodName': $translate.instant(isCustomDaysBack ? '1 Month  Back': '30 Days Back'),
					'value': '30'
				}, {
					'timePeriodName': $translate.instant(isCustomDaysBack ? '3 Month  Back': '90 Days Back'),
					'value': '90'
				}, {
					'timePeriodName': $translate.instant(isCustomDaysBack ? '6 Month  Back': '180 Days Back'),
					'value': '180'
				}, {
					'timePeriodName': $translate.instant('1 Year Back'),
					'value': '365'
				}, {
					'timePeriodName': $translate.instant('Previous Fiscal Year'),
					'value': 'previous'
				}, {
					'timePeriodName': $translate.instant('Current and Previous Fiscal Years'),
					'value': 'curAndPrev'
				}, {
					'timePeriodName': $translate.instant('Current Fiscal Year'),
					'value': 'current'
				}, {
					'timePeriodName': $translate.instant('Current Fiscal YTD'),
					'value': 'currentFiscalYTD'
				}, {
					'timePeriodName': $translate.instant('Next Fiscal Year'),
					'value': 'next'
				}, {
					'timePeriodName': $translate.instant('Current and Next Fiscal Years'),
					'value': 'currentAndNext'
				}, {
					'timePeriodName': $translate.instant('Custom'),
					'value': 'custom'
				}],
				setQueryParam: setQueryParam,
				dashboardEventName: 'adfTimePeriodChanged',
				getValidTimePeriodValue: getValidTimePeriodValue
			};
		}

		function getCustomNumericalFilterObject(id, displayName, optionsList, customOptionName, dashboardEventName) {
			optionsList.push({
				'label': $translate.instant(customOptionName),
				'value': 'custom'
			});
			return {
				id: id,
				displayName: displayName,
				type: 'numerical',
				label: 'label',
				comparisonKey: 'value',
				objectList: optionsList,
				dashboardEventName: dashboardEventName,
				setQueryParam: setQueryParam
			};
		}
	}
})();
